import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { states } from '@/constants/lifecycle';
import Fetch from '../hooks/fetch';
import Selectors from '../hooks/selectors';

const listItems = (groups) => groups.map(({ code: value, name: text }) => ({
  key: `user_groups_${value}`,
  icon: 'users',
  text,
  value,
}));

const UserGroupsDropdown = ({
  category,
  className,
  disabled,
  onChange,
  values,
}) => {
  const intl = useIntl();
  const { readStatus, groups } = Selectors.useUserGroupsDropdown({ category });
  Fetch.useFetchUsergroups({ category }, readStatus);

  return (
    <Dropdown
      className={`aridhia-user-groups-dropdown max-content ${className}`}
      options={listItems(groups)}
      disabled={disabled}
      value={values}
      fluid
      multiple
      search
      selection
      loading={readStatus === states.PENDING}
      placeholder={intl.formatMessage({ id: 'user.groups.placeholder' })}
      onChange={onChange}
    />
  );
};

export default UserGroupsDropdown;
